module.exports = __webpack_public_path__ + "img/1535191117.c05e44d4.jpg";